import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AgGridAngular } from 'ag-grid-angular';
import { ColDef, GridApi, GridReadyEvent, RowClickedEvent } from 'ag-grid-community';

@Component({
  selector: 'app-ag-grid-table',
  //imports: [CommonModule,FormsModule,AgGridAngular],
  templateUrl: './ag-grid-table.component.html',
  styleUrl: './ag-grid-table.component.css',
  standalone:false
})
export class AgGridTableComponent {
  @Input() showPagination = true;
  @Input() columnDefs: ColDef[] = [];
  @Input() rowData: any[] = [];
  @Input() loading = false;
  @Input() fitColumns = true;
  @Input() currentPage = 1;
  @Input() totalPages = 0;
  @Input() totalRecords = 0;
  @Input() pageSize = 10;

  @Output() cellClicked = new EventEmitter<any>();
  @Output() pageChange = new EventEmitter<number>();
  @Output() pageSizeChange = new EventEmitter<number>();
  @Output() rowClicked = new EventEmitter<any>();
  @Output() gridReady = new EventEmitter<GridReadyEvent>();
  @Output() selectionChanged = new EventEmitter<any[]>();

  gridApi!: GridApi;
  pageSizeOptions: number[] = [];
  
  private resizeObserver?: ResizeObserver;
  defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    //flex: 1
  };
    constructor(
    private elementRef: ElementRef
  ) {}
  
   ngAfterViewInit(): void {

    if (!this.fitColumns) {
      return;
    }

    const tableWrapper =
      this.elementRef.nativeElement.querySelector('.table-wrapper');

    if (!tableWrapper) {
      return;
    }

    this.resizeObserver = new ResizeObserver(() => {

      this.fitGridColumns();

    });

    this.resizeObserver.observe(tableWrapper);
  }

  ngOnChanges() {
    this.setPageSizeOptions();
     if (this.gridApi && this.fitColumns) {
    //setTimeout(() => this.gridApi.sizeColumnsToFit());
     this.fitGridColumns();
  }
  }

   private fitGridColumns(): void {

    if (!this.gridApi || !this.fitColumns) {
      return;
    }

    setTimeout(() => {

      if (!this.gridApi) {
        return;
      }

      this.gridApi.sizeColumnsToFit();

    }, 100);
  }

  /*private setPageSizeOptions() {

    const total = this.totalRecords;

    if (!total) {
      this.pageSizeOptions = [5, 10];
      return;
    }

    let options: number[] = [];

    if (total <= 10) options = [5];
    else if (total <= 50) options = [5, 10, 25];
    else if (total <= 200) options = [10, 25, 50, 100];
    else if (total <= 1000) options = [25, 50, 100, 200];
    else options = [50, 100, 200, 500];

    options = options.filter(x => x < total);

    if (!options.includes(this.pageSize)) {
      options.push(this.pageSize);
    }

    options.push(total);

    this.pageSizeOptions = [...new Set(options)].sort((a, b) => a - b);
  }*/
 private setPageSizeOptions() {

  const total = this.totalRecords;

  if (!total) {
    this.pageSizeOptions = [10];
    return;
  }

  let options: number[] = [];

  if (total <= 10) {
    options = [10];
  }
  else if (total <= 50) {
    options = [10, 25];
  }
  else if (total <= 200) {
    options = [10, 25, 50, 100];
  }
  else if (total <= 1000) {
    options = [25, 50, 100, 200];
  }
  else {
    options = [50, 100, 200, 500];
  }

  options = options.filter(x => x <= total);

  if (!options.includes(this.pageSize) && this.pageSize <= total) {
    options.push(this.pageSize);
  }

  if (!options.includes(total)) {
    options.push(total);
  }

  this.pageSizeOptions = [...new Set(options)]
    .sort((a, b) => a - b);
}

  goFirstPage() {
    this.pageChange.emit(1);
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.pageChange.emit(this.currentPage - 1);
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.pageChange.emit(this.currentPage + 1);
    }
  }

  goLastPage() {
    this.pageChange.emit(this.totalPages);
  }

 onPageSizeChange(event: Event) {
  const value = +(event.target as HTMLSelectElement).value;



  this.pageSize = value;



  this.pageSizeChange.emit(this.pageSize);
}

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
     if (this.fitColumns) {
    this.gridApi.sizeColumnsToFit();
  }
    this.gridReady.emit(params);
  }

  onRowClicked(event: RowClickedEvent) {
    this.rowClicked.emit(event.data);
  }

  onCellClicked(event: any) {
  this.cellClicked.emit(event);
}

onSelectionChanged() {
  this.selectionChanged.emit(this.gridApi.getSelectedRows());
}

 ngOnDestroy(): void {

    this.resizeObserver?.disconnect();

  }



}